import { useNavigate } from "react-router-dom";
// import type { BookingDetailUI, BookingStatus } from "../booking-detail.types";
import { BookingDetailUI, BookingStatus } from "../booking-detail.types";
const STATUS_LABEL: Record<BookingStatus, string> = {
  confirmed: "예약완료",
  cancelled: "취소됨",
};

const STATUS_STYLE: Record<BookingStatus, { bg: string; text: string; border: string }> = {
  confirmed: { bg: "#EFF6FF", text: "#2563EB", border: "#BFDBFE" },
  cancelled: { bg: "#FEF2F2", text: "#DC2626", border: "#FECACA" },
};

interface Props {
  booking: BookingDetailUI;
  isConfirm: boolean;
  onShare: () => void;
  onTextShare: () => void;
}

export default function BookingDetailHeader({ booking, isConfirm, onShare, onTextShare }: Props) {
  const navigate = useNavigate();
  const statusStyle = STATUS_STYLE[booking.status];

  return (
    <div
      className="bg-white border-b sticky top-0 z-30"
      style={{ borderColor: "#E5E7EB" }}
    >
      <div className="flex items-center gap-2 px-4 py-3 lg:hidden">
        <button
          onClick={() => navigate(isConfirm ? "/reservations" : (-1 as never))}
          className="w-10 h-10 flex items-center justify-center rounded-xl cursor-pointer flex-shrink-0 transition-colors"
          style={{ color: "#374151" }}
        >
          <i className="ri-arrow-left-line text-xl"></i>
        </button>
        <div className="flex-1 min-w-0">
          <h1 className="text-sm font-bold leading-tight truncate" style={{ color: "#111827" }}>
            드레스 투어 예약 상세
          </h1>
          <p className="text-xs font-mono mt-0.5" style={{ color: "#9CA3AF" }}>
            {booking.code}
          </p>
        </div>
        <span
          className="text-xs font-semibold px-2.5 py-1 rounded-full flex-shrink-0 whitespace-nowrap"
          style={{
            backgroundColor: statusStyle.bg,
            color: statusStyle.text,
            border: `1px solid ${statusStyle.border}`,
          }}
        >
          {STATUS_LABEL[booking.status]}
        </span>
        <div className="flex items-center gap-1 flex-shrink-0">
          <button
            onClick={onShare}
            className="w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-colors"
            style={{ color: "#6B7280", backgroundColor: "#F9FAFB" }}
            title="공유"
          >
            <i className="ri-share-line text-base"></i>
          </button>
          <button
            onClick={onTextShare}
            className="w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-colors"
            style={{ color: "#6B7280", backgroundColor: "#F9FAFB" }}
            title="텍스트 복사"
          >
            <i className="ri-file-copy-line text-base"></i>
          </button>
        </div>
      </div>

      <div className="hidden lg:flex items-center gap-4 px-8 py-4">
        <button
          onClick={() => navigate(isConfirm ? "/reservations" : (-1 as never))}
          className="w-10 h-10 flex items-center justify-center rounded-xl cursor-pointer flex-shrink-0 transition-colors hover:bg-gray-100"
          style={{ color: "#374151" }}
        >
          <i className="ri-arrow-left-line text-xl"></i>
        </button>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3">
            <h1 className="text-lg font-bold" style={{ color: "#111827" }}>
              드레스 투어 예약 상세
            </h1>
            <span
              className="text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap"
              style={{
                backgroundColor: statusStyle.bg,
                color: statusStyle.text,
                border: `1px solid ${statusStyle.border}`,
              }}
            >
              {STATUS_LABEL[booking.status]}
            </span>
          </div>
          <p className="text-sm font-mono mt-0.5" style={{ color: "#9CA3AF" }}>
            {booking.code}
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={onTextShare}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap transition-colors hover:bg-gray-50"
            style={{ color: "#6B7280", border: "1px solid #E5E7EB" }}
          >
            <i className="ri-file-copy-line text-sm"></i>
            텍스트 복사
          </button>
          {/* <button
            onClick={onShare}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap transition-colors"
            style={{ backgroundColor: "#2563EB", color: "#FFFFFF", display: 'none'  }}
          >
            <i className="ri-share-line text-sm"></i>
            공유하기
          </button> */}
        </div>
      </div>
    </div>
  );
}